<div class="disb-round-queue">
  @if (showHeading) {
    <div class="disb-round-queue-header">
      <h6 class="disb-round-queue-heading">รอบส่งเบิก</h6>
      <span class="disb-round-queue-count">ทั้งหมด {{ total() }} รอบ</span>
    </div>
  }

  @if (showTabs) {
    <div class="segmented-tabs segmented-tabs--sm disb-round-tabs" role="tablist" aria-label="ขั้นตอนของรอบส่งเบิก">
<button [attr.aria-selected]="activeTab() === 'all'" role="tab"
        type="button"
        class="segmented-tab"
        [class.active]="activeTab() === 'all'"
        (click)="onTabChange('all')"
      >
        ทั้งหมด
      </button>
<button [attr.aria-selected]="activeTab() === 'pending'" role="tab"
        type="button"
        class="segmented-tab"
        [class.active]="activeTab() === 'pending'"
        (click)="onTabChange('pending')"
      >
        รอดำเนินการ
      </button>
    </div>
  }

  @if (listLoading()) {
    <p class="disb-round-empty">กำลังโหลดรอบส่งเบิก...</p>
  } @else if (rounds().length === 0) {
    <p class="disb-round-empty">{{ emptyLabel() }}</p>
  } @else {
    <ul class="disb-round-list">
      @for (round of rounds(); track round.id) {
        <li class="disb-round-card">
          <div class="disb-round-card-head">
            <div class="disb-round-card-title">
              <h6>{{ roundTitle(round) }}</h6>
              <app-status-badge
                [tone]="statusDisplay(round).tone"
                [label]="statusDisplay(round).label"
              />
            </div>
            <div class="disb-round-card-meta">
              <span>{{ departmentName(round) }}</span>
              <span>{{ pathLabel(round) }}</span>
              <span>{{ roundNoLabel(round) }}</span>
              <span>เทอมการศึกษา {{ academicTermLabel(round) }}</span>
              <span>ลงวันที่ {{ formatDate(round.issued_on) }}</span>
            </div>
          </div>

          <div class="disb-round-figures">
            <span class="disb-round-figure">
              <span class="disb-round-figure-label">รายชื่อ</span>
              <span class="disb-round-figure-value">{{ memberCountLabel(round) }}</span>
            </span>
            <span class="disb-round-figure">
              <span class="disb-round-figure-label">จำนวนอาจารย์</span>
              <span class="disb-round-figure-value">{{ round.teacher_count }}</span>
            </span>
            <span class="disb-round-figure">
              <span class="disb-round-figure-label">ยอดรวมทั้งหมด (บาท)</span>
              <span class="disb-round-figure-value">{{ formatAmount(round.total_amount) }}</span>
            </span>
          </div>

          @if (isReturned(round) && round.send_back_comment) {
            <div class="disb-round-returned">
              <strong>เหตุผลที่ส่งกลับแก้ไข:</strong>
              <p class="disb-round-returned-comment">{{ round.send_back_comment }}</p>
              @if (round.send_back_by?.full_name) {
                <span class="disb-round-returned-by">
                  โดย {{ round.send_back_by?.full_name }} เมื่อ {{ formatDate(round.returned_at) }}
                </span>
              }
            </div>
          }

          <div class="disb-round-stepper" aria-label="ขั้นตอนการรับรองรอบส่งเบิก">
            <ol class="disb-round-stepper-list">
              @for (entry of round.approval_track; track entry.station) {
                <li class="disb-round-stepper-item" [ngClass]="'disb-round-stepper-' + entry.state">
                  <span class="disb-round-stepper-role">{{ entry.role_label }}</span>
                  <span class="disb-round-stepper-names">{{ stationPersonNames(entry) }}</span>
                  @if (entry.state === 'done' && entry.acted_at) {
                    <span class="disb-round-stepper-date">ดำเนินการเมื่อ {{ formatDate(entry.acted_at) }}</span>
                  }
                  @if (entry.state === 'current') {
                    <span class="disb-round-stepper-current-badge">รอดำเนินการ</span>
                  }
                </li>
              }
            </ol>
          </div>

          <div class="disb-round-members">
            <span class="disb-round-members-label">รายการ</span>
            <ul class="disb-round-members-list">
              @for (member of round.certifications; track member.id) {
                <li class="disb-round-member">
                  <span class="disb-round-member-name">{{ member.label }}</span>
                  <span class="disb-round-member-amount">{{ formatAmount(member.amount) }}</span>
                </li>
              }
            </ul>
          </div>

          <div class="disb-round-doc">
            <button
              type="button"
              class="disb-round-doc-header"
              [disabled]="!round.round_merged_fresh"
              (click)="onTogglePreview(round)"
            >
              <span>เอกสารส่งเบิกฉบับรวม</span>
              <span class="disb-round-doc-toggle">
                @if (!round.round_merged_fresh) {
                  กำลังจัดทำเอกสาร...
                } @else {
                  {{ isPreviewExpanded(round.id) ? 'ซ่อนตัวอย่าง' : 'ดูตัวอย่าง' }}
                }
              </span>
            </button>
            @if (isPreviewExpanded(round.id)) {
              <div class="disb-round-doc-preview">
                @if (isPreviewLoading(round.id)) {
                  <p class="disb-round-doc-preview-loading">กำลังโหลดเอกสารรวมของรอบ...</p>
                } @else if (previewHasError(round.id)) {
                  <p class="disb-round-doc-preview-error">{{ previewErrorMessage(round.id) }}</p>
                } @else {
                  @if (previewUrl(round.id); as url) {
                    <iframe
                      class="disb-round-doc-preview-frame"
                      [src]="url"
                      title="เอกสารส่งเบิกฉบับรวม"
                    ></iframe>
                  }
                }
              </div>
            }
          </div>

          <div class="disb-round-actions">
            @if (isWindowClosed(round)) {
              <span class="disb-round-window-closed-note">หมดเขตส่งเบิกแล้ว</span>
            }

            @if (canSendBack(round)) {
              <button
                type="button"
                class="btn disb-round-send-back-button"
                [disabled]="actionLoading()"
                (click)="onOpenSendBackDialog(round)"
              >
                ส่งกลับแก้ไข
              </button>
            }
            @if (canActPrimary(round)) {
              <button
                type="button"
                class="btn disb-round-primary-button"
                [disabled]="actionLoading()"
                (click)="onOpenPrimaryConfirm(round)"
              >
                {{ primaryActionLabel(round) }}
              </button>
            }
          </div>
        </li>
      }
    </ul>

    <app-table-pagination
      [page]="page()"
      [limit]="limit()"
      [total]="total()"
      [totalPage]="totalPage()"
      [offset]="(page() - 1) * limit()"
      [dataLength]="rounds().length"
      [pageSizeOptions]="pageSizeOptions"
      ariaLabel="disbursement round pagination"
      (pageChange)="onPageChange($event)"
      (limitChange)="onLimitChange($event)"
    ></app-table-pagination>
  }
</div>

<app-confirm-dialog
  #roundConfirmDialog
  modalId="disbursementRoundPrimaryConfirmDialog"
  icon="success"
  [title]="primaryActionDialogTitle()"
  [message]="primaryActionDialogMessage()"
  cancelText="ยกเลิก"
  [confirmText]="primaryActionDialogConfirmText()"
  [isProcessing]="actionLoading()"
  (confirmed)="onConfirmPrimaryAction()"
></app-confirm-dialog>

<app-disbursement-revision-dialog
  #sendBackDialog
  modalId="disbursementRoundSendBackDialog"
  title="ส่งกลับรอบส่งเบิกให้เจ้าหน้าที่สารบรรณ"
  subtitle="ส่งกลับแก้ไขบันทึกข้อความเบิกจ่ายค่าตอบแทนการสอน"
  confirmText="ยืนยันส่งกลับแก้ไข"
  [isProcessing]="actionLoading()"
  [stackAboveModal]="false"
  (submitted)="onSendBackSubmitted($event)"
  (cancelled)="onSendBackCancelled()"
></app-disbursement-revision-dialog>

<app-confirm-dialog
  #actionSuccessDialog
  modalId="disbursementRoundSuccessDialog"
  icon="success"
  [title]="successTitle()"
  [message]="successMessage()"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="actionSuccessDialog.close()"
></app-confirm-dialog>
